import React from "react";
import { connect } from "react-redux";
import {
  Row,
  Col,
  Container,
  FormGroup,
  Spinner,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Button
} from "reactstrap";

import axios from "axios";
import SystemLabel from "../../../../../../../system/SystemLabel/SystemLabel";
import { systemLabelActions } from "../../../../../../../store/actions/system/systemLabel/systemLabel.action";
import "./ArticleEditor.css";
import ArticleMedia from "../../components/ArticleMediaUploader/ArticleMedia";
import { history } from "../../../../../../../helpers/history";
import Notifier from "../../../../../../../components/UI/Notifier/Notifier";
import { MobileLoader } from "../../../../../../../components/UI/Spinner/MobileLoader";
import { arrayHelper } from "../../../../../../../helpers/arrayHelper";
import {
  resetOrientation,
  dataURLtoFile
} from "../../../../../../../helpers/imageHelper";
class ArticleEditor extends React.Component {
  state = {
    headerImage: "",
    title: "",
    subtitle: "",
    content: "",
    likes: 0,
    publishDate: null,
    media: [],
    mediaVm: [],
    headerImageFd: null,
    errorMessage: "",
    article: null,
    previewHeaderImage: "",
    alert: null,
    loading: false,
    prevHeaderImage: null,
    prevMediaLength: 0,
    published: false,
    mediaUploaded: false,
    count: 0,
    headerRotation: 0,
    headerFile: null
  };
  componentDidMount() {
    const { user, dispatch } = this.props;
    window.scrollTo(0, 0);
    const userLang = user && user.userLang === undefined ? user.token.userLang : user.userLang;
    if (user && userLang) {
      dispatch(systemLabelActions.getGroup(user.userLang, "Article.Edit"));
    }
    if (this.checkIfEdit()) {
      this.getArticle();
    }
  }

  validate = () => {
    const { article } = this.state;
    if (article) {
      if (article.title.length < 1) {
        this.setState(
          { alert: { message: /* 'adawd' */ "Titel saknas!", type: "error" } },
          () => {
            setTimeout(() => {
              this.setState({ alert: null });
            }, 2000);
          }
        );
        return false;
      }
    } else {
      const { publishDate, content, title } = this.state;

      if (title.length < 1) {
        this.setState(
          { alert: { message: /* 'adawd' */ "Titel saknas!", type: "error" } },
          () => {
            setTimeout(() => {
              this.setState({ alert: null });
            }, 2000);
          }
        );
        return false;
      }
    }
    return true;
  };
  checkIfEdit = () => {
    const { match } = this.props;
    if (match.params.id) {
      return true;
    }
    return false;
  };
  getArticle = () => {
    this.setState({ loading: true });
    const { match } = this.props;
    const articleId = match.params.id;
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json" }
    };
    fetch(`./api/article/getbyarticleid/${articleId}`, requestOptions)
      .then(res => res.json())
      .then(article => {
        this.setState({
          article,
          loading: false,
          alert: null
        });

        this.getMedia();
      })
      .catch(err => {
        this.setState({ errorMessage: err, media: [] });
      });
  };
  previewImage = res => {
    this.setState({ previewHeaderImage: res });
  };
  onUpload = (event, headerImage = false) => {
    event.preventDefault();
    const files = Array.from(event.target.files);
    let f = new FormData();
    if (headerImage) {
      if (this.state.article && this.state.article.headerImage) {
        const prevHeaderImage = this.state.mediaVm.find(m => {
          return m.url === this.state.article.headerImage;
        });
        if (prevHeaderImage) {
          this.onMediaDelete(prevHeaderImage.name);
        }
      }
      f.append("File", files[0]);
      const reader = new FileReader();
      let url = reader.readAsDataURL(files[0]);
      reader.onloadend = () => {
        this.setState({
          previewHeaderImage: reader.result
        });
      };
      this.setState({ headerImageFd: f, headerFile: files[0] });
      return;
    }
    let mediaVm = Array.from(this.state.mediaVm);
    let mediaF = Array.from(event.target.files);
    for (let index = 0; index < files.length; index++) {
      mediaF.push(files[index]);
      mediaVm.push({
        name: files[index].name,
        type: files[index].type
      });
    }

    let media = Array.from(this.state.media);
    media = arrayHelper.concat(media, mediaF);
    this.setState({ media, mediaVm });
  };
  onUpload2 = (event, headerImage = false) => {
    event.preventDefault();
    const files = Array.from(event.target.files);
    let f = new FormData();

    if (headerImage) {
      if (this.state.article && this.state.article.headerImage) {
        const prevHeaderImage = this.state.mediaVm.find(m => {
          return m.url === this.state.article.headerImage;
        });
        if (prevHeaderImage) {
          this.onMediaDelete(prevHeaderImage.name);
        }
      }
      const reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onloadend = () =>
        this.parseImageUpload(
          {
            name: files[0].name,
            size: files[0].size,
            type: files[0].type,
            file: reader.result
          },
          true
        );
      f.append("File", files[0]);

      this.setState({ headerImageFd: f });
      return;
    }
    let mediaVm = Array.from(this.state.mediaVm);
    let mediaF = Array.from(event.target.files);
    for (let index = 0; index < files.length; index++) {
      const reader = new FileReader();
      reader.readAsDataURL(files[index]);
      if (files[0].name.includes("image.jpg")) {
        reader.onloadend = () =>
          this.parseImageUpload({
            name: files[index].name,
            size: files[index].size,
            type: files[index].type,
            file: reader.result
          });
      } else {
        mediaF.push(files[index]);
        mediaVm.push({
          name: files[index].name,
          type: files[index].type
        });
      }
    }
    let media = Array.from(this.state.media);
    media = arrayHelper.concat(media, mediaF);
    this.setState({ media, mediaVm });
    return;
  };

  parseImageUpload = (res, headerImage = false) => {
    if (headerImage) {
      if (res.name.includes("image.jpg")) {
        let srcOrientation = 6;
        resetOrientation(res.file, srcOrientation, resetBase64Image => {
          const file = dataURLtoFile(resetBase64Image, res.name);
          this.setState({
            headerImageFd: file,
            previewHeaderImage: resetBase64Image
          });
        });
      }

      if (res.type.includes("video")) {
        this.setState({
          previewHeaderImage: "https://i.stack.imgur.com/PtbGQ.png"
        });
      } else {
        this.setState({ previewHeaderImage: res.file });
      }
    } else {
      let mediaVm = Array.from(this.state.mediaVm);
      let media = Array.from(this.state.media);
      const result = Object.assign({}, res);

      let srcOrientation = 6;
      resetOrientation(res.file, srcOrientation, resetBase64Image => {
        const file = dataURLtoFile(resetBase64Image, res.name);
        /*  result.file = file; */
        media.push(file);
        this.setState({ media });
      });

      media.push(result);
      mediaVm.push({
        name: res.name,
        type: res.type
      });
      this.setState({ media, mediaVm });
    }
  };

  deleteArticle = () => {
    const articleId = this.state.article.articleId;
    const requestOptions = {
      method: "DELETE",
      headers: /* authHeader( */ { "Content-Type": "application/json" } /* ) */
    };
    fetch(`./api/article/${articleId}`, requestOptions)
      .then(res => {
        this.setState(
          {
            article: null,
            media: [],
            mediaVm: [],
            alert: {
              message: /* 'adawd' */ "Artikeln togs bort!",
              type: "warning"
            }
          },
          () => {
            setTimeout(() => {
              this.setState({ alert: null }, () => {
                history.push("/articles/edit");
              });
            }, 2000);
          }
        );
      })
      .catch(err => {
        this.setState({ errorMessage: err, media: [] });
      });
  };
  update = (callback = false) => {
    if (callback === false && !this.validate()) {
      return;
    }
    this.setState({ loading: true });
    if (this.state.headerImageFd && callback === false) {
      this.uploadHeaderImage(this.state.article.articleId);
    }
    if (this.state.media.length > 0 && callback === false) {
      this.uploadToStorage(this.state.article.articleId);
    }
    let articleToUpdate = Object.assign({}, this.state.article);
    const requestOptions = {
      method: "PUT",
      headers: /* authHeader( */ { "Content-Type": "application/json" } /* ) */,
      body: JSON.stringify(articleToUpdate)
    };
    fetch(`./api/article/`, requestOptions)
      .then(res => res.json())
      .then(newArticle => {
        this.setState(
          {
            article: newArticle,
            loading: false,
            media: []
          },
          () => { }
        );
      })
      .catch(err => {
        this.setState({ errorMessage: err });
      });
  };
  getMedia = () => {
    const article = this.state.article;
    if (!article) {
      return;
    }
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json" }
    };
    fetch(
      `./api/files/article/${article.eventId}/?articleId=${article.articleId}`,
      requestOptions
    )
      .then(res => res.json())
      .then(files => {
        const newMedia = Array.from(files);
        const headerFile = newMedia.find(m => {
          return m.url === this.state.article.headerImage;
        });
        this.setState({
          mediaVm: newMedia,
          media: [],
          headerFile: headerFile
        });
      })
      .catch(err => {
        this.setState({ errorMessage: err });
      });
  };
  onMediaDelete = fileName => {
    const article = this.state.article;
    if (!article) {
      return;
    }
    if (!fileName) {
      return;
    }

    const requestOptions = {
      method: "DELETE",
      headers: /* authHeader( */ { "Content-Type": "application/json" } /* ) */
    };
    fetch(
      `./api/files/article/${article.articleId}/?fileName=${fileName.substring(
        fileName.lastIndexOf("/") + 1
      )}`,
      requestOptions
    )
      .then(res => {
        let newMedia = Array.from(this.state.mediaVm);

        const indexOf = newMedia.indexOf(
          newMedia.find(m => {
            return m.name === fileName;
          })
        );
        newMedia.splice(indexOf, 1);
        this.setState({ mediaVm: newMedia });
      })
      .catch(err => {
        this.setState({ errorMessage: err });
      });
  };
  /*     hadHeaderImage */
  publish2 = () => {
    if (!this.validate()) {
      return;
    }
    this.setState({ loading: true });
    const article = Object.assign({}, this.state);
    axios
      .post(`./api/article/`, article, {
        headers: { "Content-Type": "application/json" }
      })
      .then(res => {
        const newArticle = res.data;
        this.setState({ article: newArticle, loading: false });

        if (this.state.headerImageFd) {
          var apiBaseUrl = `./api/files/?articleId=${newArticle.articleId}`;

          axios
            .post(apiBaseUrl, this.state.headerImageFd, {
              headers: { "Content-Type": "application/json" }
            })
            .then(res => {
              const data = Object.assign({}, res.data);
              const articleToUpdate = this.state.article;
              articleToUpdate.headerImage = data.url;
              this.setState({
                article: articleToUpdate,
                previewHeaderImage: "",
                headerImageFd: null,
                headerImage: data.url
              });

              axios
                .put("./api/article/", articleToUpdate, {
                  headers: { "Content-Type": "application/json" }
                })
                .then(res => {
                  const newArticle = res.data;
                  const media = [...new Set(this.state.media)];
                  let apiBaseUrl = `./api/files/?articleId=${newArticle.articleId}`;

                  for (let index = 0; index < media.length; index++) {
                    /*      let f = new FormData();
                                             f.append("File", media[index]); */
                    axios
                      .post(apiBaseUrl, media[index], {
                        headers: { "Content-Type": "application/json" }
                      })
                      .then(res => {
                        const data = Object.assign({}, res.data);

                        const media = Array.from(this.state.mediaVm);
                        const indexOf = media.indexOf(
                          media.find(m => {
                            return (
                              m.name === data.name ||
                              m.name.includes("image.jpg")
                            );
                          })
                        );
                        media.splice(indexOf, 1);
                        media.push(data);

                        this.setState({
                          mediaVm: media
                        });
                        if (index === media.length - 1) {
                          this.setState({
                            mediaUploaded: true
                          });
                          this.setState(
                            {
                              /*   alert: { message: 'Artikeln är publicerad!', type: 'success' }, */
                              published: true,
                              loading: false
                            },
                            () => {
                              history.push(
                                "/articles/edit/" + this.state.article.articleId
                              );
                              /*     this.publishAlert(); */
                            }
                          );
                        }
                      })
                      .catch(err => this.setState({ loading: false }));
                  }
                })
                .catch(err => this.setState({ loading: false }));
            })
            .catch(err => this.setState({ loading: false }));
        } else {
          const media = [...new Set(this.state.media)];
          var apiBaseUrl2 = `./api/files/?articleId=${newArticle.articleId}`;
          for (let index = 0; index < media.length; index++) {
            axios
              .post(apiBaseUrl2, media[index], {
                headers: { "Content-Type": "application/json" }
              })
              .then(res => {
                const data = Object.assign({}, res.data);

                const media = Array.from(this.state.mediaVm);
                const indexOf = media.indexOf(
                  media.find(m => {
                    return m.name === data.name || m.name.includes("image.jpg");
                  })
                );
                media.splice(indexOf, 1);
                media.push(data);

                this.setState({
                  mediaVm: media
                });
                if (index === media.length - 1) {
                  this.setState({
                    mediaUploaded: true
                  });
                  this.setState(
                    {
                      /*   alert: { message: 'Artikeln är publicerad!', type: 'success' }, */
                      published: true,
                      loading: false
                    },
                    () => {
                      history.push(
                        "/articles/edit/" + this.state.article.articleId
                      );
                      /*     this.publishAlert(); */
                    }
                  );
                }
              });
          }
        }
      })
      .catch(err => this.setState({ loading: false }));
  };
  publish = () => {
    if (!this.validate()) {
      return;
    }
    this.setState({ loading: true });
    const article = Object.assign({}, this.state);

    axios
      .post(`./api/article/`, article, {
        headers: { "Content-Type": "application/json" }
      })
      .then(res => {
        const newArticle = res.data;
        this.setState({ article: newArticle });

        if (this.state.headerImageFd) {
          var apiBaseUrl = `./api/files/basic/?articleId=${newArticle.articleId}`;

          axios
            .post(apiBaseUrl, this.state.headerImageFd, {
              headers: { "Content-Type": "multipart/form-data" }
            })
            .then(res => {
              const data = Object.assign({}, res.data);
              const articleToUpdate = this.state.article;
              articleToUpdate.headerImage = data.url;
              this.setState({
                article: articleToUpdate,
                previewHeaderImage: "",
                headerImageFd: null,
                headerImage: data.url
              });

              axios
                .put("./api/article/", articleToUpdate, {
                  headers: { "Content-Type": "application/json" }
                })
                .then(res => {
                  this.setState({ loading: false });
                  const newArticle = res.data;
                  const media = [...new Set(this.state.media)];
                  var apiBaseUrl = `./api/files/basic/?articleId=${newArticle.articleId}`;
                  for (let index = 0; index < media.length; index++) {
                    let f = new FormData();
                    f.append("File", media[index]);
                    axios
                      .post(apiBaseUrl, f, {
                        headers: { "Content-Type": "multipart/form-data" }
                      })
                      .then(res => {
                        const data = Object.assign({}, res.data);

                        const media = Array.from(
                          this.state.mediaVm.filter(m => {
                            return m.url !== undefined;
                          })
                        );
                        /*    const indexOf = media.indexOf(
                                                    media.find(m => {
                                                        return m.name.includes(data.name) || m.name.includes('image.jpg');
                                                    })
                                                ); */
                        /*       media.splice(indexOf, 1); */
                        media.push(data);

                        this.setState({
                          mediaVm: media
                        });
                        if (index === media.length - 1) {
                          this.setState(
                            {
                              published: true,

                              mediaUploaded: true
                            },
                            () => {
                              history.push(
                                "/articles/edit/" + this.state.article.articleId
                              );
                            }
                          );
                        }
                      })
                      .catch(err => {
                        console.error(err);
                        this.setState({ loading: false });
                      });
                  }
                });
            })
            .catch(err => {
              console.error(err);
              this.setState({ loading: false });
            });
        } else {
          this.setState({ loading: false });
          const media = [...new Set(this.state.media)];
          /*  const  */
          var apiBaseUrl2 = `./api/files/basic/?articleId=${newArticle.articleId}`;
          for (let index = 0; index < media.length; index++) {
            let f = new FormData();
            f.append("File", media[index]);
            axios
              .post(apiBaseUrl2, f, {
                headers: { "Content-Type": "multipart/form-data" }
              })
              .then(res => {
                const data = Object.assign({}, res.data);

                const media = Array.from(
                  this.state.mediaVm.filter(m => {
                    return m.url !== undefined;
                  })
                );

                media.push(data);

                this.setState({
                  mediaVm: media
                });
                if (index === media.length - 1) {
                  this.setState(
                    {
                      mediaUploaded: true,
                      published: true
                    },
                    () => {
                      history.push(
                        "/articles/edit/" + this.state.article.articleId
                      );
                      /*     this.publishAlert(); */
                    }
                  );
                }
              })
              .catch(err => {
                console.error(err);
                this.setState({ loading: false });
              });
          }
        }
      });
  };

  publishAlert = () => {
    setTimeout(() => {
      this.setState({ alert: null }, () => { });
    }, 2000);
  };
  uploadHeaderImage = articleId => {
    var apiBaseUrl = `./api/files/basic/?articleId=${articleId}`;
    if (this.state.headerImageFd) {
      axios
        .post(apiBaseUrl, this.state.headerImageFd, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(res => {
          const data = Object.assign({}, res.data);
          const articleToUpdate = this.state.article;
          articleToUpdate.headerImage = data.url;

          /*  if (this.state.headerImageFd.type.includes('video')) {
                         let videoHeader = 'thumbnail-' + this.state.headerImageFd;
                         axios
                             .post(apiBaseUrl, this.state.headerImageFd, {
                                 headers: { "Content-Type": "multipart/form-data" }
                             });
                     }
  */
          this.setState({
            article: articleToUpdate,
            previewHeaderImage: "",
            headerImageFd: null,
            headerImage: data.url,
            headerFile: data
          });
          this.update(true);
          /* return data.url; */
        })
        .catch(err => console.error(err));
    }
  };
  uploadToStorage = (articleId, publish = false) => {
    var apiBaseUrl = `./api/files/basic/?articleId=${articleId}`;
    const media = [...new Set(this.state.media)];
    for (let index = 0; index < media.length; index++) {
      let f = new FormData();
      f.append("File", media[index]);
      axios
        .post(apiBaseUrl, f, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(res => {
          const data = Object.assign({}, res.data);
          const media = Array.from(
            this.state.mediaVm.filter(m => {
              return m.url !== undefined;
            })
          );
          /*         const indexOf = media.indexOf(
                        media.find(m => {
                            return m.name.includes(data.name) || m.name.includes('image.jpg');
                        })
                    );

                    media.splice(indexOf, 1); */
          media.push(data);

          this.setState({
            mediaVm: media
          });
          if (index === media.length - 1) {
            this.setState({
              mediaUploaded: true
            });
          }
        })
        .catch(err => console.error(err));
    }
  };
  onChange = e => {
    const { name, value } = e.target;

    if (this.state.article) {
      const article = Object.assign({}, this.state.article);
      article[name] = value;
      this.setState({ article });
      return;
    }
    this.setState({
      [name]: value
    });
  };
  backToFeedView = () => {
    if (this.state.article) {
      history.push("/news/articles/" + this.state.article.eventId);
    } else {
      history.push("/news/articles/" + this.props.user.eid);
    }
  };
  createView = () => {
    this.setState({
      headerImage: "",
      title: "",
      subtitle: "",
      content: "",
      likes: 0,
      publishDate: null,
      media: [],
      mediaVm: [],
      headerImageFd: null,
      errorMessage: "",
      article: null,
      previewHeaderImage: "",
      alert: null,
      loading: false,
      prevMediaLength: 0,
      published: false,
      mediaUploaded: false
    });
    history.push("/articles/edit");
  };
  render() {
    const {
      media,
      article,
      title,
      subtitle,
      publishDate,
      content,
      headerImage,
      mediaVm,
      loading,
      headerFile
    } = this.state;
    return (
      <Container className="editor-container">
        {loading === true && <MobileLoader />}
        <Row className="editor-row">
          {article &&
            article.headerImage &&
            !this.state.previewHeaderImage &&
            headerFile &&
            (headerFile.type.includes("image") ? (
              <div className="article-header">
                <img src={article.headerImage} alt="blank" />
              </div>
            ) : (
                <div className="article-header">
                  <video id={article.headerImage} controls loop autoPlay>
                    <source src={article.headerImage} type="video/mp4" />
                    <source src={article.headerImage} type="video/quicktime" />
                  </video>
                </div>
              ))}
          {this.state.previewHeaderImage && (
            <div className="article-header">
              <img src={this.state.previewHeaderImage} alt="blank" />
            </div>
          )}
        </Row>
        <Row className="editor-row">
          <label htmlFor="header-image-upload" className="media-upload-button">
            <i className="fa fa-upload"></i>
            {"  "}
            <SystemLabel name="HeaderImage" />
          </label>
          <input
            id="header-image-upload"
            className="file-upload"
            type="file"
            accept="image/*, video/*"
            onChange={e => this.onUpload(e, true)}
          />
        </Row>
        <Row className="editor-row">
          <FormGroup className="editor-formgroup">
            <Label for="title">
              <SystemLabel name="Title" />
            </Label>
            <Input
              onChange={this.onChange}
              name="title"
              value={article ? article.title : title}
              type="text"
              id="title"
            />
          </FormGroup>
        </Row>
        <Row className="editor-row">
          <FormGroup className="editor-formgroup">
            <Label for="subtitle">
              <SystemLabel name="Subtitle" />
            </Label>
            <Input
              onChange={this.onChange}
              name="subtitle"
              value={article ? article.subtitle : subtitle}
              type="text"
              id="subtitle"
            />
          </FormGroup>
        </Row>
        <Row className="editor-row">
          <FormGroup className="editor-formgroup">
            <Label for="publishDate">
              <SystemLabel name="PublishDate" />
            </Label>
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="fa fa-calendar" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                onChange={this.onChange}
                name="publishDate"
                value={
                  article
                    ? article.publishDate
                    : /* new Date( */ publishDate && publishDate /* ) */
                }
                list={true}
                type="datetime-local"
                id="publishDate"
              />
            </InputGroup>
          </FormGroup>
        </Row>
        <Row className="editor-row">
          <FormGroup className="editor-formgroup">
            <Label for="body">
              <SystemLabel name="Body" />
            </Label>
            <Input
              onChange={this.onChange}
              name="content"
              className="editor-content-area"
              value={article ? article.content : content}
              type="textarea"
              id="body"
            />
          </FormGroup>
        </Row>
        <Row className="editor-row ">
          <label htmlFor="media-upload" className="media-upload-button">
            <i className="fa fa-upload"></i>
            {"  "}
            <SystemLabel name="UploadMedia" />
          </label>
          <input
            id="media-upload"
            className="file-upload"
            type="file"
            multiple
            accept="image/*, video/*"
            onChange={e => this.onUpload(e)}
          />
        </Row>
        {/*      <Row>
          <Col>
            <p className="text-muted">
              <i className="fa fa-info-circle" />{" "}
              <SystemLabel name="PhonePhotoInfo" />
            </p>
          </Col>
        </Row> */}
        <Row className="editor-row " style={{ marginBottom: "40px" }}>
          <ArticleMedia
            onDelete={this.onMediaDelete}
            media={mediaVm}
            headerImage={article ? article.headerImage : headerImage}
            editMode={article != null}
          />
        </Row>
        <Row className="editor-row toolbar ">
          {!this.state.loaded && article ? (
            <React.Fragment>
              <Button
                color="primary"
                className="toolbar-btn"
                onClick={this.createView}
              >
                <SystemLabel name="CreateNew" />
              </Button>
              <Button
                color="success"
                className="toolbar-btn"
                onClick={() => this.update(false)}
              >
                <SystemLabel name="Update" />
              </Button>
              <Button
                color="danger"
                className="toolbar-btn"
                onClick={this.deleteArticle}
              >
                <SystemLabel name="Delete" />
              </Button>
            </React.Fragment>
          ) : (
              <Button
                color="success"
                className="toolbar-btn"
                onClick={this.publish}
              >
                <SystemLabel name="Publish" />
              </Button>
            )}
          <Button
            color="primary"
            className="toolbar-btn"
            onClick={this.backToFeedView}
          >
            <SystemLabel name="Feed" />
          </Button>
        </Row>
        {this.state.alert && (
          <Notifier
            message={this.state.alert.message}
            type={this.state.alert.type} /* systemLabel={true} */
          />
        )}
      </Container>
    );
  }
}
function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
    alert: state.alert,
    systemLabel: state.systemLabel
  };
}
export default connect(mapStateToProps)(ArticleEditor);
